import React, { useState } from "react";
import { champPath } from "../misc/Static";
import Champ from "../images/Champ";
import Elo from "../misc/Elo";
import Item from "../images/Item";
import Spell from "../images/Spell";
import KeyStonePlus from "../misc/KeystonePlus";
import MatchExtraDetails from "./MatchExtraDetails";
import { Link } from "react-router-dom";
import styles from "./MatchRow.module.css";

export const MatchRow = ({ match, calc, p, width }) => {
  const [active, setActive] = useState(false);
  const expandDetails = () => setActive(!active);
  const tier = match.tier[p].toLowerCase();
  const division = match.division[p];
  return (
    <>
      <div className={styles[width]}>
        <div className={styles.champ}>
          <a
            href={
              "https://lolalytics.com/lol/" +
              champPath(match.champion[p]) +
              "/build/"
            }
          >
            <Champ type="champ50b" id={match.champion[p]} />
          </a>
          <div>{match.champLevel[p]}</div>
        </div>
        <div className={styles.runes}>
          <KeyStonePlus
            keystone={match.perk0[p]}
            secondary={match.perkSubStyle[p]}
          />
        </div>
        <div className={styles.summoners}>
          <div>
            <Spell type="spell24" id={match.spell[p][0]} />
            <Spell type="spell24" id={match.spell[p][1]} />
          </div>
        </div>
        <div className={styles.summoner}>
          <Link to={match.pathName[p]}>
            <div>{match.summonerName[p]}</div>
          </Link>
        </div>
        {width === "xsmall" && <Elo tier={tier} division={division} />}
        {width !== "xsmall" && (
          <div className={styles.tier}>
            <img
              src={`https://cdn5.xdx.gg/emblem32/${tier}.webp`}
              srcSet={`https://cdn5.xdx.gg/emblem32/${tier}.webp 32w,
              https://cdn5.xdx.gg/emblem64/${tier}.webp 64w,
              https://cdn5.xdx.gg/emblem96/${tier}.webp 96w`}
              width="32"
              height="32"
              alt={match.tier[p]}
            />
            <div>
              {tier} {division}
            </div>
          </div>
        )}
        <div className={styles.items}>
          {match.items[p].map((item, i) => (
            <React.Fragment key={"item" + i}>
              {item === 0 && <div className={styles.placeholder}></div>}
              {item > 0 && <Item type="item24r" id={item} />}
            </React.Fragment>
          ))}
        </div>
        <div className={styles.kda}>
          <div>{calc.kda[p]}</div>
          <div>
            <span>{match.kills[p]}</span>/<span>{match.deaths[p]}</span>/
            <span>{match.assists[p]}</span>
          </div>
          <div>{calc.kp[p]}% KP</div>
        </div>
        <div className={styles.damage}>
          {match.totalDamageDealtToChampions[p].toLocaleString()}
          <div></div>
          <div
            style={{
              width: `${
                (match.totalDamageDealtToChampions[p] / calc.maxDamage) * 100
              }%`,
            }}
          ></div>
        </div>
        {width !== "xsmall" && (
          <div className={styles.vision}>
            <div>
              <div>
                <img
                  data-type="tips"
                  data-id="control"
                  src="https://cdn5.xdx.gg/icons/control.webp"
                  width="24"
                  height="24"
                  alt="Control Wards"
                />
              </div>
              <div>
                <img
                  data-type="tips"
                  data-id="wards"
                  src="https://cdn5.xdx.gg/icons/ward.webp"
                  width="24"
                  height="24"
                  alt="Wards Placed"
                />
              </div>
              <div>
                <img
                  data-type="tips"
                  data-id="wardskilled"
                  src="https://cdn5.xdx.gg/icons/wardkilled.webp"
                  width="24"
                  height="24"
                  alt="Wards Killed"
                />
              </div>
            </div>
            <div>
              <div>{match.visionWardsBoughtInGame[p]}</div>
              <div>{match.wardsPlaced[p]}</div>
              <div>{match.wardsKilled[p]}</div>
            </div>
          </div>
        )}
        <div className={styles.gold}>
          {Math.round(match.goldEarned[p] / 1000)}K
        </div>
        <div className={styles.cs}>
          <div>{match.neutralMinionsKilled[p]}</div>
          <div>{calc.totalMinions[p]}</div>
        </div>
        <div className={styles.expand} onClick={expandDetails}>
          {active ? "-" : "+"}
        </div>
      </div>
      {active && <MatchExtraDetails match={match} pid={p} width={width} />}
    </>
  );
};
export default MatchRow;
